<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import slugify from "slugify";
    import {itemMapper, validateColumns} from "../utils";

    export let open: boolean = false;
    export let templateURL: string = '';
    const dispatcher = createEventDispatcher();
    export let columns: Array<any> = []

    let rows = [];
    let errors = [];
    let valid = true;
    let pasted = false;

    function copyFromClipboard() {
        rows = [];
        errors = [];
        pasted = true;
        navigator.clipboard.readText().then((response) => {
            const data = response.split('\n').map(s => s.split('\t')).map((row: any) => {
                return row.reduce((acc: Array<any>, i) => {
                    if (!!i && i != '\r') {
                        acc.push(i)
                    } else {
                        acc.push('')
                    }
                    return acc;
                }, [])
            });
            const header = data.slice(0, 1)[0].map(s => slugify(`${s}`.toLowerCase(), {
                lower: true,
                trim: true,
                strict: true
            }));
            data.splice(0, 1);
            const raw = data.reduce((acc: any, e: any) => {
                acc.push(header.reduce((obj: any, h: any, index: number) => {
                    obj[h] = e[index];
                    return obj;
                }, {}))
                return acc
            }, []);
            const processed = validateColumns(raw.filter(row => header.some(c => !!row[c])), columns, itemMapper);
            rows = processed.items || [];
            valid = processed.valid || false;
            errors = processed.errors
        });
    }

    function close() {
        pasted = false;
        valid = true;
        rows = []
        dispatcher('close', {})
    }

    function load() {
        dispatcher('load', {
            items: rows.map((r: any) => {
                return {
                    number: r['item']?.value,
                    group: r['grupo']?.value,
                    code: r['codigo-institucional']?.value,
                    name: r['descripcion-producto']?.value,
                    quantity: r['cantidad-solicitada']?.value,
                    roof: r['precio-techo']?.value,
                    disabled: true
                }
            })
        });
        pasted = false;
        valid = true;
        rows = [];
    }


</script>

<div class="clipboard-background" class:active={open}>
    <div class="clipboard-content">
        <div class="overflow-y-scroll">
            <i class="fal fa-times close-clip" on:click={close}></i>
            <fieldset>
                <legend>Copiar de portapapeles</legend>
            </fieldset>
            {#if errors?.length > 0}
                <div class="logs mb-1">
                    <code>
                        {#each errors as e}
                            {e}<br>
                        {/each}
                    </code>
                </div>
            {/if}
            {#if rows?.length > 0}
                <div>
                    <div class="radius py-ii px-1 back-gray my-ii" style="display: inline-block;">
                        <strong>{rows?.length}</strong> Registros
                    </div>
                </div>
            {/if}
            <table class="naui-table w-100">
                <thead>
                <tr>
                    <th></th>
                    {#each columns as col}
                        <th>
                            <div>
                                {col.label}
                            </div>
                        </th>
                    {/each}
                </tr>
                </thead>
                <tbody>
                {#each rows as row, i}
                    <tr>
                        <td>
                            <div>
                                {i + 1}
                            </div>
                        </td>
                        {#each columns as col}
                            <td>
                                <div class:col-error={row[col.slug]?.error}>
                                    {row[col.slug]?.value}
                                </div>
                            </td>
                        {/each}
                    </tr>
                {/each}

                </tbody>
            </table>
        </div>
        <div class="grid-3-1 bottom shadow">
            <div class="box-l">
                <div class="box-l">
                    {#if pasted}
                        {#if valid && rows?.length > 0}
                            <div class="disclaimer pl-2">
                                <b>DATOS CORRECTOS: </b> Los datos pegados cuentan con la estructura correcta y podrán
                                ser
                                cargados en el requerimiento
                            </div>
                        {:else}
                            <div class="disclaimer pl-2 box-l">
                                <div style="min-width: 90px;">
                                    <i class="fal fa-exclamation-triangle"></i>
                                    <b>ERROR:</b>
                                </div>
                                <div>
                                    Por datos pegados no tiene la estructura requerida para realizar el cargue. Revise
                                    los
                                    datos y vuelva a intentarlo. También puede descargar la plantilla para subir los
                                    datos
                                    con la función masiva.
                                </div>
                            </div>
                        {/if}
                    {/if}
                </div>
            </div>
            <div class="box-r sx-ii">
                {#if valid}
                    {#if rows?.length > 0}
                        <NauiButton color="accent"
                                    mode="outline"
                                    caption="CARGAR DATOS"
                                    on:click={load}/>
                    {:else }
                        <NauiButton on:click={copyFromClipboard}
                                    color="accent"
                                    mode="outline"
                                    caption="PEGAR"/>
                    {/if}
                {:else}
                    {#if templateURL}
                        <NauiButton color="accent"
                                    mode="outline"
                                    class="mr-1"
                                    href={templateURL}
                                    caption="DESCARGAR TEMPLATE"/>
                    {/if}
                    <NauiButton on:click={copyFromClipboard}
                                color="accent"
                                mode="outline"
                                caption="PEGAR"/>
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .clipboard-background {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(54, 54, 54, .45);
        z-index: 30;
        opacity: 0;
        transform: translateX(100%);
        transition: 0.2s ease-in-out all;
    }

    .clipboard-background.active {
        transform: translateX(0%);
        opacity: 1;
    }

    .clipboard-content {
        position: relative;
        background-color: white;
        width: calc(100% - 4rem);
        height: calc(100% - 4rem);
        border-radius: 10px;
        margin-top: 2rem;
        margin-left: 2rem;
        z-index: 40;
        padding: 2rem 2rem;
        display: grid;
        grid-template-rows: 1fr 50px;
    }

    fieldset {
        margin-bottom: 0;
    }

    .clipboard-content table div {
        padding: .5rem;
    }

    .clipboard-content table div.col-error {
        border: 1px solid red;
    }

    .naui-table th > div,
    .naui-table th > div {
        padding: 0 .2rem;
    }

    .clipboard-content .bottom {
        background-color: #FAFAFA;
        border-radius: 5px;
    }

    .close-clip {
        position: absolute;
        right: 2rem;
        font-size: 1.5rem;
        cursor: pointer;
    }

    .disclaimer,
    .disclaimer * {
        color: var(--primary);
    }
</style>